export default "__VITE_ASSET__CqHtlJ82__"